export default __webpack_public_path__ + "static/media/upload-document-white.35839a67.svg";